import * as React from 'react';
import classNames from 'classnames';
import IMPComponent from '../../interfaces/IMPComponent';

import './styles.scss';

interface IFormLabelProps extends IMPComponent {
  children: React.ReactNode;
}

const FormLabel: React.FunctionComponent<IFormLabelProps> = ({ className, ...props }) => {
  const cn = classNames('FormLabel', className);

  return <label className={cn} {...props} />;
};

export default React.memo(FormLabel);



// WEBPACK FOOTER //
// ./src/components/Form/FormLabel/index.tsx